import { Component, NgZone, OnInit, ViewChild, ChangeDetectorRef, TemplateRef, ElementRef, AfterViewInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../guards/service/auth.service';
import { FreelancerDataService } from '../../../services/freelancer-data.service';
import { ToastrService } from 'ngx-toastr';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule, formatDate } from '@angular/common';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DndDirective } from '../../directives/dnd.directive';
import { MdbModalService, MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { EditProfileComponent } from './modals/edit-profile/edit-profile.component';
import { DomainService } from '../../domain/domain.service';
import { Location } from '@angular/common';
import { CommunityService } from '../../../services/community.service';
import { PostItemComponent } from '../post-item/post-item.component';
import { PostStoreService } from '../home/postService/post-store.service';
import { SocketService } from '../../../services/socket.service';

type Traffic = 'green' | 'yellow' | 'red' | 'unknown';
type DesignationDTO = { id: number | null; designation: string };

function normalizeId(v: unknown): number | null {
  if (v === null || v === undefined) return null;
  if (typeof v === 'string') {
    const s = v.trim();
    if (s === '') return null;
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
  }
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  return null;
}

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [NgbDropdownModule, NgbNavModule, CommonModule, NgxDocViewerModule, DndDirective, ReactiveFormsModule, PostItemComponent],
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css'],
  providers: [MdbModalService]
})
export class ProfileComponent implements OnInit, AfterViewInit {
  profilePhoto = 'https://kontact-app-public.s3-ap-southeast-1.amazonaws.com/images/Sign-Up-Image.jpg';
  spaceID = 0;
  selectedFile: File | null = null;
  profileDetails: any;
  profileDesignation: any;
  profileResume: any;
  profileSkills: any;
  userId = 0;
  jobseekerId = 0;
  viewerType: 'google' | 'office' | 'pdf' = 'pdf';
  extension: any;
  uploadResumeFileForm!: UntypedFormGroup;
  profileUrlBase = 'https://profile.staging.connect.kontactapp.com/';
  datalocalURL?: string;
  @ViewChild('editProfileModal') editProfileModal: any;
  alias: any;
  profileUrl: any;
  name = '';
  designation = '';
  shareOption?: boolean;
  communityID = 0;
  userPosts: any[] = [];
  isMobile = false;
  activeReplyPostId: number | null = null;
  submittingReplyPostId: number | null = null;
  isLoadingUserPosts = false;
  parentReplyDepth = 0;
  parentPostId: number | null = null;
  replyContent = '';
  replyImages: File[] = [];
  replyImagePreviews: string[] = [];
  expandedPosts: Set<number> = new Set();
  profileNotificationSettings: any;
  replyPostSettings?: boolean;
  consultantRegistration: any;
  availabiltyDurations: { duration_id: number; value: string }[] = [];
  availability: any;
  availabilityForm!: UntypedFormGroup;
  @ViewChild('availabilityModal') availabilityModal!: TemplateRef<any>;
  @ViewChild('shareAvailabilityModal') shareAvailabilityModal!: TemplateRef<any>;
  modalRef: MdbModalRef<any> | null = null;
  currentAvailability = { start_at: null as string | null, duration_id: null as number | null };
  @ViewChild('aboutMeEl') aboutMeEl!: ElementRef;
  showFullAbout = false;
  isClamped = false;
  activeTabId: 'overview' | 'cv' | 'availability' | 'settings' | 'posts' = 'overview';
  traffic: Traffic = 'unknown';
  availabilityBannerMsg = '';
  showAvailabilityBanner = true;
  private returnUrl: string | null = null;
  IsRecruiter = false;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private dataService: FreelancerDataService,
    private toastrService: ToastrService,
    private modalService: MdbModalService,
    private ngZone: NgZone,
    public domainService: DomainService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private communityService: CommunityService,
    private postStore: PostStoreService,
    private socketService: SocketService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.spaceID = parseInt(localStorage.getItem('spaceID') || '0', 10) || 0;
      this.isMobile = window.innerWidth < 768;
    }
    this.updateUserActive();

    if (this.domainService.isCommunityDomain()) {
      const routeSlug = this.route.snapshot.paramMap.get('slug');
      const routeCommunityId = this.route.snapshot.paramMap.get('communityId');
      const savedSlug = localStorage.getItem('slug');
      const savedCommunityId = localStorage.getItem('communityId');
      if (routeSlug !== savedSlug || routeCommunityId !== savedCommunityId) {
        this.router.navigate([`/${savedSlug}/${savedCommunityId}/profile`]);
        return;
      }

      const communityId = parseInt(routeCommunityId || '0', 10) || 0;
      this.communityID = communityId;
      if (communityId) this.socketService.joinCommunity(communityId);
      this.socketService.connect();

      this.socketService.listenToPostUpdated().subscribe((data: any) => {
        if (!data?.post || !data?.id) return;
        const currentUrl = this.router.url;
        if (/^\/[^/]+\/\d+\/profile$/.test(currentUrl)) this.getUserCommunityPost();
      });

      this.getUserCommunityPost();
      this.getFreelancerProfileVisibilityData();
    }

    this.getFreelancerAvatar();
    this.getFreelancerPersonalInfo();
    this.getFreelanceProfileNotificationSetting();
    this.getFreelancerDesignation();
    this.getFreelancerResume();
    this.getFreelancerSkills();
    this.initializeResumeUploadFileForm();
    this.initializeAvailabilityAddForm();
    this.getConsultantRegistrationDataList();

    this.route.queryParamMap.subscribe((qp) => {
      const tab = (qp.get('tab') as any) ?? 'overview';
      const status = (qp.get('status') as Traffic) ?? 'unknown';
      const ret = qp.get('returnUrl');
      this.activeTabId = this.normalizeTab(tab);
      this.traffic = status;
      this.returnUrl = ret;
      this.setAvailabilityBanner(status);
    });
  }

  ngAfterViewInit(): void { setTimeout(() => this.checkClampedLines(), 0); }
  toggleAbout(): void { this.showFullAbout = !this.showFullAbout; }

  checkClampedLines(): void {
    const el = this.aboutMeEl?.nativeElement;
    if (!el) return;
    const lineHeight = parseFloat(getComputedStyle(el).lineHeight || '20');
    this.isClamped = el.scrollHeight > lineHeight * 5;
  }

  updateUserActive(): void {
    const h = this.spaceID;
    this.dataService.updateUserActive(h).subscribe({ next: () => {}, error: () => {} });
  }

 getFreelancerPersonalInfo(): void {
  const h = this.spaceID;
  this.dataService.getFreelancerProfile({}, h).subscribe({
    next: (res) => {
      const data = res?.data || {};

     
      data.education = Array.isArray(data.education)
        ? data.education.map((e: any) => ({
            degree: e?.degree || 'Not specified',
            institute: e?.institute || 'N/A',
            start_year: e?.start_year || '',
            end_year: e?.end_year || ''
          }))
        : [];

      data.experience = Array.isArray(data.experience)
        ? data.experience.map((exp: any) => ({
            title: exp?.title || 'Not specified',
            company: exp?.company || 'N/A',
            start_year: exp?.start_year || '',
            end_year: exp?.end_year || ''
          }))
        : [];

   
      const eduLevels = data.educationLevels || [];
      const expYears = data.experienceYears || [];

      const eduMatch = eduLevels.find(
        (e: any) => e.education_level_id === data.education_level_id
      );
      const expMatch = expYears.find(
        (x: any) => x.experience_years_id === data.experience_years_id
      );

      data.education_level = eduMatch?.value || 'Not specified';
      data.experience_years = expMatch?.value || 'Not specified';

     
      this.profileDetails = data;
      this.userId = Number(data?.user_id) || 0;
      this.jobseekerId = Number(data?.jobseeker_id) || 0;
      this.name = data?.name ?? '';

      this.getFreelancerResume();

      if (this.domainService.isCommunityDomain()) {
        this.getRecruiterStatus();
      }

      this.cdRef.detectChanges();
    },
    error: (err) => console.error('Error fetching profile:', err)
  });
}


  getRecruiterStatus(): void {
    const d = { user_id: this.userId || 0, space_id: this.spaceID || 0, community_id: this.communityID || 0 };
    this.communityService.getRecruiterStatus(d).subscribe({
      next: (res) => {
        this.IsRecruiter = !!res?.data?.is_recruiter;
        if (!this.IsRecruiter) this.getUserAvailability();
      },
      error: () => {
        this.IsRecruiter = false;
        this.getUserAvailability();
      }
    });
  }

  getFreelancerAvatar(): void {
    const h = this.spaceID;
    this.dataService.getFreelancerAvatar({}, h).subscribe({
      next: (res) => (this.profilePhoto = res?.data),
      error: (err) => console.error('Error fetching avatar:', err)
    });
  }

  getFreelancerDesignation(): void {
    const h = this.spaceID;
    this.dataService.getFreelancerDesignations({}, h).subscribe({
      next: (res) => {
        this.profileDesignation = res?.data;
        this.designation = this.profileDesignation?.[0]?.designation || '';
      },
      error: (err) => console.error('Error fetching designation:', err)
    });
  }

  getFreelancerResume(): void {
    const h = this.spaceID;
    this.dataService.getFreelancerResume({}, h).subscribe({
      next: (res) => {
        this.profileResume = res?.data;
        const resumeName: string | undefined = this.profileResume?.resumeName;
        if (this.userId > 0 && this.jobseekerId > 0 && resumeName) this.showResume(this.userId, this.jobseekerId, resumeName);
      },
      error: (err) => console.error('Error fetching resume:', err)
    });
  }

  showResume(user_id: number, jobseeker_id: number, resume_name: string) {
    this.dataService.displayResume({ user_id, jobseeker_id }, resume_name).subscribe((bytes) => {
      const ext = (resume_name.split('.').pop() || '').toLowerCase();
      const mime = { docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', pdf: 'application/pdf', doc: 'application/msword' } as const;
      const viewer = { pdf: 'pdf', doc: 'office', docx: 'office' } as const;
      if (!(ext in mime) || !(ext in viewer)) return;
      this.viewerType = viewer[ext as keyof typeof viewer];
      const blob = new Blob([bytes], { type: mime[ext as keyof typeof mime] });
      this.datalocalURL = window.URL.createObjectURL(blob);
    });
  }

    onPhotoUpload(event: any) {
    this.selectedFile = event.target.files?.[0] || null;
    if (!this.selectedFile) return;
    const limit = 10 * 1024 * 1024;
    const formats = ['jpg', 'jpeg', 'png', 'gif'];
    const ext = this.selectedFile.name.split('.').pop()?.toLowerCase() || '';
    if (!formats.includes(ext)) {
      this.toastrService.error('Please upload supported file formats.');
      return;
    }
    if (this.selectedFile.size > limit) {
      this.toastrService.error('File Size Limit Exceeded.');
      return;
    }
    const fd = new FormData();
    fd.append('avatar', this.selectedFile);
    const h = this.spaceID;
    this.dataService.uploadAvatar(fd, h).subscribe({
      next: (res: any) => {
        this.toastrService.success(res.data);
        this.getFreelancerAvatar();
      },
      error: (e) => this.toastrService.error(e?.error?.error?.description)
    });
  }

  initializeResumeUploadFileForm() {
    this.uploadResumeFileForm = this.fb.group({ resume: new UntypedFormControl(null) });
  }

  onFileDropped(event: any) {
    const resume = event?.[0];
    if (!resume) {
      this.toastrService.error('No file detected in the drop area.');
      return;
    }
    const valid = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    const max = 5 * 1024 * 1024;
    if (!valid.includes(resume.type)) {
      this.uploadResumeFileForm.get('resume')?.setErrors({ invalidFileType: true });
      this.toastrService.error('Only PDF, DOC, DOCX allowed.');
      return;
    }
    if (resume.size > max) {
      this.uploadResumeFileForm.get('resume')?.setErrors({ invalidFileSize: true });
      this.toastrService.error('File too large.');
      return;
    }
    const fd = new FormData();
    fd.append('resume', resume);
    const h = this.spaceID;
    this.dataService.uploadResume(fd, h).subscribe({
      next: (res: any) => {
        this.toastrService.success(res.data);
        this.uploadResumeFileForm.reset();
        this.getFreelancerResume();
      },
      error: (e) => this.toastrService.error(e?.error?.error?.description)
    });
  }

  onFileSelect(event: any) {
    const resume = event.target.files?.[0];
    if (!resume) {
      this.toastrService.error('No file selected.');
      return;
    }
    const valid = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    const max = 5 * 1024 * 1024;
    if (!valid.includes(resume.type)) {
      this.toastrService.error('Only PDF, DOC, DOCX allowed.');
      this.uploadResumeFileForm.get('resume')?.setErrors({ invalidFileType: true });
      return;
    }
    if (resume.size > max) {
      this.toastrService.error('File too large.');
      this.uploadResumeFileForm.get('resume')?.setErrors({ invalidFileSize: true });
      return;
    }
    const fd = new FormData();
    fd.append('resume', resume);
    const h = this.spaceID;
    this.dataService.uploadResume(fd, h).subscribe({
      next: (res: any) => {
        this.toastrService.success(res.data);
        this.uploadResumeFileForm.reset();
        this.getFreelancerResume();
      },
      error: (e) => this.toastrService.error(e?.error?.error?.description)
    });
  }

  editProfileClicked() {
    const modalRef = this.modalService.open(EditProfileComponent, {
      modalClass: 'modal-lg',
      backdrop: true,
      ignoreBackdropClick: true
    });
    setTimeout(() => {
      modalRef.component.profileData = this.profileDetails;
      modalRef.component.profileDesignation = this.profileDesignation?.[0];
      modalRef.component.IsRecruiter = this.IsRecruiter;
      modalRef.component.onSaveCallback = (u: any) => this.handleProfileSave(u);
      modalRef.component.setupForm();
    }, 0);
  }

  handleProfileSave(updated: { profilePayload: any; otherPayload: { designations: DesignationDTO[] } }) {
    const h = this.spaceID;
    const { profilePayload, otherPayload } = updated;
    const cleaned: DesignationDTO[] = (otherPayload?.designations || [])
      .map((d) => ({
        id: normalizeId((d as any)?.id),
        designation: String(d?.designation ?? '').trim()
      }))
      .filter((d) => d.designation.length > 0 && (d.id === null || d.id > 0));
    const seen = new Set<string>();
    const unique = cleaned.filter((d) => {
      const key = d.designation.toLowerCase();
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
    const desigPayload = { designations: unique };
    this.dataService.updateProfileInfo(profilePayload, h).subscribe({
      next: () => {
        if (!desigPayload.designations.length) {
          this.toastrService.success('Profile updated');
          this.getFreelancerPersonalInfo();
          return;
        }
        this.dataService.updateProfileDesignation(desigPayload, h).subscribe({
          next: () => {
            this.toastrService.success('Profile and designations updated');
            this.getFreelancerPersonalInfo();
            this.getFreelancerDesignation();
          },
          error: () => {
            this.toastrService.warning('Profile saved, designation failed');
            this.getFreelancerPersonalInfo();
          }
        });
      },
      error: () => this.toastrService.error('Failed to update profile')
    });
  }

  getUserCommunityPost(): void {
    this.route.params.subscribe((p) => (this.communityID = +(p['communityId'] || 0)));
    if (!this.communityID) return;
    this.isLoadingUserPosts = true;
    this.communityService.getUserCommunityPosts(this.communityID, {}).subscribe({
      next: (res) => {
        const posts = Array.isArray(res?.data?.data) ? res.data.data : [];
        this.userPosts = posts.map((p: any) => ({
          ...p,
          showReplies: false,
          replies: [],
          repliesLoaded: false
        }));
        this.isLoadingUserPosts = false;
      },
      error: () => {
        this.toastrService.error('Failed to load user posts.');
        this.userPosts = [];
        this.isLoadingUserPosts = false;
      }
    });
  }

  toggleReply({
    replyId,
    replyDepth,
    parentPostId,
    onDone
  }: {
    replyId: number;
    replyDepth: number;
    parentPostId: number;
    onDone?: () => void;
  }): void {
    this.parentReplyDepth = replyDepth;
    this.parentPostId = parentPostId;
    this.activeReplyPostId = this.isMobile ? replyId : this.activeReplyPostId === replyId ? null : replyId;
    this.communityService.getReplies(this.communityID, parentPostId).subscribe({
      next: (res) => {
        const replies = Array.isArray(res) ? res : res?.data?.data || [];
        const t = this.userPosts.find((p: any) => p.id === parentPostId);
        if (t) {
          t.replies = replies;
          t.showReplies = true;
          t.repliesLoaded = true;
        }
      },
      error: () => this.toastrService.error('Failed to load replies.'),
      complete: () => {
        if (onDone) onDone();
      }
    });
  }

  submitReply({
    parentId,
    replyDepth,
    content,
    files
  }: {
    parentId: number;
    replyDepth: number;
    content: string;
    files: File[];
  }) {
    const hasText = content.trim().length > 0;
    const hasImgs = files.length > 0;
    if (!hasText && !hasImgs) {
      this.toastrService.warning('Reply must contain text or image');
      return;
    }
    this.submittingReplyPostId = parentId;
    const fd = new FormData();
    fd.append('content', content);
    fd.append('parent_post_id', parentId.toString());
    fd.append('reply_depth', (replyDepth + 1).toString());
    files.forEach((f) => fd.append('files', f));
    const query = { bucket: 'Community/post-attachments' };
    this.communityService.createPost(this.communityID, fd, query).subscribe({
      next: () => {
        this.toastrService.success('Reply posted');
        this.toggleReply({
          replyId: parentId,
          replyDepth,
          parentPostId: parentId,
          onDone: () => (this.submittingReplyPostId = null)
        });
      },
      error: (e) => {
        const msg = e?.error?.error?.description || 'Failed to create post.';
        this.toastrService.error(msg);
        if (msg === 'Your account has been suspended.') this.onLogout();
      }
    });
  }

  getFreelanceProfileNotificationSetting(): void {
    const h = this.spaceID;
    this.dataService.getFreelancerProfileNotificationSettings({}, h).subscribe({
      next: (res) => {
        this.profileNotificationSettings = res?.data;
        this.replyPostSettings = this.profileNotificationSettings?.on_reply_post;
      },
      error: (err) => console.error('Error fetching notification setting:', err)
    });
  }

  toggleEmailNotification(e: any): void {
    const enabled = !!e?.target?.checked;
    const h = this.spaceID;
    const data = { on_reply_post: enabled };
    this.dataService.updateFreelancerEmailNotificationSettings(data, h).subscribe({
      next: (res) => {
        this.toastrService.success(res?.data?.data);
        this.replyPostSettings = enabled;
        this.getFreelanceProfileNotificationSetting();
        this.cdRef.detectChanges();
      },
      error: (err) => this.toastrService.error(err?.error?.error?.description)
    });
  }

  getConsultantRegistrationDataList(): void {
    this.dataService.getconsultantRegistration().subscribe({
      next: (res) => {
        this.consultantRegistration = res?.data;
        this.availabiltyDurations = this.consultantRegistration?.durations || [];
      },
      error: (err) => console.error('Error fetching consultant registration:', err)
    });
  }

  initializeAvailabilityAddForm() {
    this.availabilityForm = this.fb.group({
      mode: ['now'],
      start_at: [null],
      duration_id: [null]
    });
  }

  getUserAvailability(): void {
    const h = this.spaceID;
    this.dataService.getUserAvailabilty({}, h).subscribe({
      next: (res) => {
        if (res?.success) {
          const av = res.data?.availability || {};
          this.currentAvailability = {
            start_at: av.start_at || null,
            duration_id: Number(av.duration_id) || null
          };
          if (Array.isArray(res.data?.durations)) this.availabiltyDurations = res.data.durations;
          const startAt = av.start_at ? new Date(av.start_at) : null;
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const startAtDate = startAt ? new Date(startAt.setHours(0, 0, 0, 0)) : null;
          const nowMode = !startAtDate || startAtDate <= today;
          this.availabilityForm.patchValue({
            mode: nowMode ? 'now' : 'date',
            start_at: av.start_at?.split('T')[0] || null,
            duration_id: av.duration_id ? Number(av.duration_id) : null
          });
          this.cdRef.detectChanges();
        }
      },
      error: (err) => console.error('Error fetching availability:', err)
    });
  }

  onModeChange(): void {
    const mode = this.availabilityForm.get('mode')?.value;
    if (mode === 'now') this.availabilityForm.patchValue({ start_at: null });
    else if (mode === 'date') this.availabilityForm.patchValue({ duration_id: null });
  }
  saveAvailability(): void {
    const data = this.availabilityForm.value;
    const today = new Date();
    const todayDate = formatDate(today, 'yyyy-MM-dd', 'en-MY');
    const formatted = data.mode === 'now'
      ? `${todayDate} 00:00:00.000`
      : `${data.start_at} 00:00:00.000`;

    const payload = {
      availability: {
        start_at: formatted,
        duration_id:
          data.mode === 'now'
            ? data.duration_id
              ? parseInt(data.duration_id, 10)
              : null
            : null
      }
    };

    const h = this.spaceID;
    this.dataService.updateUserAvailabilty(payload, h).subscribe({
      next: (res) => {
        this.toastrService.success(res?.data);
        this.getUserAvailability();
        this.closeModal();
        if (this.returnUrl) this.router.navigateByUrl(this.returnUrl);
      },
      error: (err) =>
        this.toastrService.error(
          err?.error?.error?.description || 'Failed to update availability'
        )
    });
  }

  initializeCreateAvaliabiltyUrl() {
    this.availabilityForm = this.fb.group({
      is_enabled: [false],
      header: [''],
      message: [''],
      alias: [''],
      hide_email: [false],
      hide_phone: [false],
      hide_profile_photo: [false]
    });
  }

  openAvailabilityModal(): void {
    this.modalRef = this.modalService.open(this.availabilityModal, {
      modalClass: 'modal-lg custom-modal',
      backdrop: true,
      ignoreBackdropClick: true,
      animation: true
    });
    setTimeout(() => this.cdRef.detectChanges(), 0);
  }

  openShareAvailabilityModal(): void {
    this.modalRef = this.modalService.open(this.shareAvailabilityModal, {
      modalClass: 'modal-dialog-centered'
    });
  }

  submitAvailabilityForm() {
    this.availability = this.availabilityForm.value;
  }

  toggleAvailabilityShare() {
    if (!this.availability) this.availability = {};
    this.availability.is_enabled = !this.availability.is_enabled;
  }

  getAvailabilityUrl(): string {
    return `https://profile.staging.kontactapp.com/availability/${this.availability?.alias}`;
  }

  closeModal(): void {
    this.modalRef?.close();
  }

  get isNowMode(): boolean {
    return this.availabilityForm.get('mode')?.value === 'now';
  }

  get isDateMode(): boolean {
    return this.availabilityForm.get('mode')?.value === 'date';
  }

  getDurationLabel(id: number | null): string {
    if (!id || id === 8) return '';
    const found = this.availabiltyDurations?.find((d) => d.duration_id === id);
    return found ? found.value : 'Unknown';
  }

  getAvailabilityStatus(av: { start_at: string | null; duration_id: number | null }): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = av?.start_at ? new Date(av.start_at) : null;
    if (start) start.setHours(0, 0, 0, 0);
    const raw = av?.duration_id ? this.getDurationLabel(av.duration_id) : null;
    const duration = raw && raw !== 'Unknown' ? raw : null;
    if (!start || start <= today)
      return duration ? `Available Now (${duration})` : 'Available Now';
    const formatted = start.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    return duration
      ? `Available From ${formatted} (${duration})`
      : `Available From ${formatted}`;
  }

  getAvailabilityBadgeClass(av: { start_at: string | null; duration_id: number | null }): string {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const start = av?.start_at ? new Date(av.start_at) : null;
    if (start) start.setHours(0, 0, 0, 0);
    if (!start || start <= today) return 'bg-success text-white';
    return 'bg-warning text-dark';
  }

  private normalizeTab(tab: string): 'overview' | 'cv' | 'availability' | 'settings' | 'posts' {
    const allowed = ['overview', 'cv', 'availability', 'settings', 'posts'] as const;
    return (allowed.includes(tab as any) ? tab : 'overview') as any;
  }

  private setAvailabilityBanner(status: Traffic) {
    switch (status) {
      case 'green':
        this.availabilityBannerMsg = 'Your availability is fresh (updated within 7 days).';
        break;
      case 'yellow':
        this.availabilityBannerMsg = 'Your availability is getting stale (updated within 14 days).';
        break;
      case 'red':
        this.availabilityBannerMsg = 'Your availability is outdated (>14 days). Please update it.';
        break;
      default:
        this.availabilityBannerMsg =
          'Set your availability to let others know your current status.';
    }
  }

  togglePublicProfile(event: any): void {
    const isEnabled = !!event?.target?.checked;
    this.route.params.subscribe((p) => (this.communityID = +(p['communityId'] || 0)));
    const data = { is_public: isEnabled };
    this.communityService.updateProfileVisibilaty(this.communityID, data).subscribe({
      next: () => {
        this.toastrService.success('Profile Share Settings Updated');
        this.getFreelancerProfileVisibilityData();
        this.cdRef.detectChanges();
      },
      error: (err) => this.toastrService.error(err?.error?.error?.description)
    });
  }

  getFreelancerProfileVisibilityData(): void {
    this.route.params.subscribe((p) => (this.communityID = +(p['communityId'] || 0)));
    if (!this.communityID) return;
    this.communityService.getProfileVisibilaty(this.communityID, {}).subscribe({
      next: (res) =>
        (this.shareOption = res?.data?.data?.is_community_profile_public),
      error: (err) => console.error('Error fetching visibility:', err)
    });
  }

  goBack(): void {
    const sameOrigin =
      typeof document !== 'undefined' &&
      document.referrer &&
      (() => {
        try {
          return new URL(document.referrer).origin === window.location.origin;
        } catch {
          return false;
        }
      })();

    if (sameOrigin && window.history.length > 1) {
      this.location.back();
      return;
    }
    if (this.returnUrl) {
      this.router.navigateByUrl(this.returnUrl);
      return;
    }
    const slug = localStorage.getItem('slug') || '';
    const communityId = localStorage.getItem('communityId') || '';
    const fallback = slug && communityId ? `/${slug}/${communityId}/home` : '/home';
    this.router.navigateByUrl(fallback);
  }

  onDeletePost(postId: number): void {
    if (!postId) return;
    this.communityService.deletePost(this.communityID, postId).subscribe({
      next: () => {
        this.getUserCommunityPost();
        this.toastrService.success('Post deleted successfully');
      },
      error: () => this.toastrService.error('Failed to delete post')
    });
  }
 getFreelancerSkills(): void {
    const h = this.spaceID;
    this.dataService.getFreelancerSkills({}, h).subscribe({
      next: (res) => {
        this.profileSkills = res?.data;
      },
      error: (err) => console.error('Error fetching consultant skills:', err)
    });
  }

  trackByPostId(index: number, post: any): number {
    return post.id;
  }
  onLogout(): void {
    this.authService.handleLogout();
  }
}
